import { apiHelper, uiHelper } from '@/util'
import { SHARED, CACHE_KEY } from '@/constants/constants'

export const gameService = {
  getGames,
  getOriginalsGames,
  getProviderTypeConfig,
  launchGame,
  gameCategories,
  getJackpot,
  getPlayerGameDetails,
  quickRegister,
  kisskayadeeplink,
  matchesHighlights,
  getHomepageHot
}

//API URLs
const GAME = {
  GAME: 'game',
  TYPES: 'types',
  CATEGORIES: 'categories',
  PLAYER_DETAILS: 'playerdetails',
  MEDIA_SERVER_URL: SHARED.MEDIA_SERVER_URL,
  SERVER_NAME: SHARED.SERVER_NAME,
  JACKPOT_URL: 'json/NAGAD88/grand_jackpot.json',
  QUICK_REGISTER: 'quickregister',
  DEEPLINK: 'kisskaya/deeplink',
  HOMEPAGE_HOT: 'homepagehot'
}

function kisskayadeeplink(data) {
  const requestBody = {
    provider: data.provider
  }
  return apiHelper().post(`/${GAME.GAME}/${GAME.DEEPLINK}`, requestBody)
}

function quickRegister(data) {
  const requestBody = {
    provider: data.provider
  }
  return apiHelper().post(`/${GAME.GAME}/${GAME.QUICK_REGISTER}`, requestBody)
}

function getPlayerGameDetails(data) {
  let requestBody = {
    params: {
      provider: data.provider
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.PLAYER_DETAILS}`, requestBody)
}

function getGames(data) {
  let requestBody = {
    params: {
      currency: data.currency,
      type: data.type,
      size: data.size,
      page: data.page,
      platform: data.platform,
      category: data.category,
      provider: data.provider,
      mode: data.mode
    }
  }
  return apiHelper().get(`/${GAME.GAME}`, requestBody)
}

// The home Originals tab and the header's Originals dropdown both load this list. A successful result is
// kept in localStorage for 60 minutes, like the other game lists, and callers asking while a request is
// still running share it, so the list costs one API call per hour instead of one per page view.
const ORIGINALS_CACHE_MINUTES = 60
const originalsInFlight = {}
function getOriginalsGames(currency, platform) {
  const key = `${CACHE_KEY.ORIGINALS_GAMES}_${platform}_${currency}`
  const cached = uiHelper.getLocalStorage(key)
  if (cached) return Promise.resolve(cached)
  if (!originalsInFlight[key]) {
    originalsInFlight[key] = getGames({ currency, type: 'originals', size: '', page: '', platform, category: '', provider: '', mode: 'All' })
    const clear = () => delete originalsInFlight[key]
    originalsInFlight[key].then(result => {
      if (result && result.success && Array.isArray(result.data)) uiHelper.setLocalStorage(key, result, ORIGINALS_CACHE_MINUTES)
      clear()
    }, clear)
  }
  return originalsInFlight[key]
}

function getProviderTypeConfig(obj) {
  const requestOptions = {
    params: {
      currency: obj.currency,
      platform: obj.platform
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.TYPES}`, requestOptions)
}

function launchGame(gameObj) {
  const requestBody = {
    provider: gameObj.provider,
    game_id: gameObj.gameId,
    game_code: gameObj.gameCode,
    is_demo: gameObj.isDemo,
    platform: gameObj.platform,
    language: gameObj.language,
    website: gameObj.webSite,
    currency: gameObj.currency,
    game_type: gameObj.gameType
  }
  return apiHelper().post(`/${GAME.GAME}`, requestBody)
}

function gameCategories() {
  return apiHelper().get(`/${GAME.GAME}/${GAME.CATEGORIES}`)
}

function getJackpot() {
  return apiHelper(`${GAME.MEDIA_SERVER_URL}`, false).get(`/${GAME.JACKPOT_URL}`)
}

function matchesHighlights() {
  return apiHelper(`${GAME.MEDIA_SERVER_URL}/${GAME.SERVER_NAME}`, false).get(`/cricket/data_${SHARED.DEFAULT_CURRENCY}json`)
}

function getHomepageHot(data) {
  let requestBody = {
    params: {
      currency: data.currency,
      size: data.size,
      page: data.page,
      platform: data.platform,
      mode: data.mode
    }
  }
  return apiHelper().get(`/${GAME.GAME}/${GAME.HOMEPAGE_HOT}`, requestBody)
}
